var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFerrari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29001",
    "data-name": "Group 29001",
    transform: "translate(-3969 5094)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3969, -5094)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-ferrari",
    transform: "translate(3984.409 -5080.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50567",
    "data-name": "Path 50567",
    d: "M21.091,2,8,4.455V15.091S7.754,29.818,21.091,38Zm0,0L34.182,4.455V15.091S34.427,29.818,21.091,38Z",
    fill: "#ed1b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50568",
    "data-name": "Path 50568",
    d: "M37.091,4.455V6.091L24,3.636V2Zm0,10.636Z",
    transform: "translate(-2.909)",
    fill: "#009a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50569",
    "data-name": "Path 50569",
    d: "M21.273,38.473C8.918,30.618,9,16.709,9,16.545V12.209A33.505,33.505,0,0,1,21.273,10a34.944,34.944,0,0,1,12.273,2.209v4.336C33.545,16.709,33.545,30.618,21.273,38.473Z",
    transform: "translate(-0.182 -1.455)",
    fill: "#fef200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50570",
    "data-name": "Path 50570",
    d: "M21.091,10.636A33.625,33.625,0,0,1,32.545,12.6v3.764c0,.164.082,13.255-11.455,20.945C9.636,29.7,9.636,16.936,9.636,16.364V12.6a34.5,34.5,0,0,1,11.455-1.964m0-1.636A32.336,32.336,0,0,0,8,11.536H8v4.827S7.754,31.091,21.091,39.273c13.336-8.182,13.091-22.909,13.091-22.909V11.536h0A32.779,32.779,0,0,0,21.091,9Z",
    transform: "translate(0 -1.273)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50571",
    "data-name": "Path 50571",
    d: "M8,4.455V6.091L21.091,3.636V2ZM8,15.091Z",
    transform: "translate(0)",
    fill: "#009a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50572",
    "data-name": "Path 50572",
    d: "M8,6.455V8.091L21.091,5.636V4ZM8,17.009ZM34.182,6.455V8.091L21.091,5.636V4Zm0,10.555Z",
    transform: "translate(0 -0.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50573",
    "data-name": "Path 50573",
    d: "M28.841,23.018a5,5,0,0,1,.491-1.964s-.818.491-.9,1.145c-.327-.655.245-1.636.245-1.636-.327.164-.736.491-.736,1.636,0,2.945-.082,2.782-.327,3.273-.082.082-.327.082-.245-.164-.082-.327.082-1.064-1.882-2.209-.9-.573-1.391-1.473-1.227-1.882a1.827,1.827,0,0,0,1.145.245,4.746,4.746,0,0,1-.982-.818,2.78,2.78,0,0,0,1.636.245,3.691,3.691,0,0,1-1.473-1.145,2.122,2.122,0,0,0,1.473.164c-.409-.164-1.064-.491-1.227-.982a2.5,2.5,0,0,0,1.391,0,3.275,3.275,0,0,1-1.391-1.064,3.117,3.117,0,0,1,1.391.327c-.164-.491-.9-.9-1.473-1.309a5.3,5.3,0,0,0,1.145,0c-.327-.327-1.064-.655-1.145-.818a1.219,1.219,0,0,0,.736-.327c-1.064,0-1.227-.818-1.636-.818-.164-.082-.409-.655-.491-.818a1.091,1.091,0,0,0-.327.818c-.982,0-1.064.573-1.309.736-1.227.491-1.391.164-1.718.491a.707.707,0,0,0-.245.491c-.082.409.082.736.573.736.164,0,.491-.245.736-.245.409,0,.818.409,1.473.409.245,0,.491-.164.9-.818-.164.9-.409,1.227-1.145,1.227a7.74,7.74,0,0,1-1.227,3.109,4.046,4.046,0,0,1-2.045.982c-.082.082-.655,0-.736.245a1.128,1.128,0,0,0,0,.736,7.912,7.912,0,0,0,.409,1.718.365.365,0,0,0,.245.327c.164.082.164.164.164.164a2.106,2.106,0,0,0,.491,1.227s.818-.982.655-1.309c-.082-.164-.573-.327-.573-.327v-.327a5.786,5.786,0,0,1-.409-1.309h1.391A8.425,8.425,0,0,0,23.277,25.8a1.533,1.533,0,0,1,1.309-.573c-1.636.164-1.636,1.964-1.227,2.7.573,1.145.573,1.391.491,1.636-.409.655-.491.736-.655.982-.082.164.082.245-.082.327a1.823,1.823,0,0,0-.982,1.064s1.391.164,1.636-.082c.082-.082.082-.491.082-.491a3.544,3.544,0,0,0,.409.082c.082-.082.245-.082.245-.164s.164-.409.164-.491a3.081,3.081,0,0,1,.736-1.227c0-.082-.409-.573-.409-.818-.082-1.064.818-.982,1.964-2.373.082-.164.245-.082.327-.082,2.127,0,1.882-1.718,2.209-3.6C28.841,23.427,28.841,23.018,28.841,23.018Z",
    transform: "translate(-1.859 -2.2)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28986",
    "data-name": "Group 28986",
    transform: "translate(17.164 23.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50574",
    "data-name": "Path 50574",
    d: "M21.164,32.109c.082,0,.245.082.327,0a1.09,1.09,0,0,1,.409-.245,4.306,4.306,0,0,1,1.473-.327.541.541,0,0,0,.082-.491,2.481,2.481,0,0,1-.409-2.373c-.082-.082-.573-.491-.655-.573a12.912,12.912,0,0,1-.082,2.373c-.736.245-1.145-.082-1.473,0-.164.082-.082.245-.245.164a1.6,1.6,0,0,0-1.391.327s.982,1.145,1.309,1.064c.082,0,.409-.327.409-.327S21,32.027,21.164,32.109Z",
    transform: "translate(-19.2 -28.1)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50575",
    "data-name": "Path 50575",
    d: "M17.409,22.245a1.634,1.634,0,0,0,.245-.655s.245,0,.327-.082l.245-.245c.245-.245.736-.655.736-.655.164.164.655.818.9,1.145a2.23,2.23,0,0,0,.818-.9c-.573-.655-1.227-1.555-1.636-1.555a11.191,11.191,0,0,0-1.8,1.555.633.633,0,0,0-.082.245,1.722,1.722,0,0,0-1.064.736S17.164,22.491,17.409,22.245Z",
    transform: "translate(-1.473 -3.145)",
    fill: "#37474f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerrari);
export default __webpack_public_path__ + "static/media/Ferrari.95647858ad5c4a1585af9671b6d9029e.svg";
export { ForwardRef as ReactComponent };